var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDepth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "776px",
    height: "776px",
    viewBox: "0 0 776 776",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckDepth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckDepth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.047807,458.432863 L413.782691,527.753654 L375.160738,588.082018 L365.875044,573.744863 L366.807133,573.254443 L366.678121,572.998531 C375.976204,568.182146 383.108514,559.234059 385.833868,547.339761 C391.239662,523.789707 377.336199,497.607847 354.785462,488.859197 C341.308141,483.631676 327.791284,485.812875 317.941884,493.440646 L314.896044,495.043863 L309.593044,486.856753 L362.047807,458.432863 Z",
    id: "Combined-Shape",
    fill: "#C5C5E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDepth);
export default __webpack_public_path__ + "static/media/CheckDepth.1740624960d8d10e6ec690e7a0073928.svg";
export { ForwardRef as ReactComponent };